module.exports = __webpack_public_path__ + "img/zlindex16.4a5c1b1d.png";